import { motion } from "framer-motion";
import { EASE, Overline } from "@/components/bits";

export default function PageHeader({ overline, title, lead, testId }) {
  return (
    <section className="bg-olive text-sand pt-40 pb-20 md:pt-52 md:pb-28">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: EASE }}
        >
          <Overline light>{overline}</Overline>
        </motion.div>
        <div className="overflow-hidden">
          <motion.h1
            data-testid={testId}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1, delay: 0.1, ease: EASE }}
            className="font-display font-light uppercase tracking-tight text-[clamp(1.8rem,4.8vw,3.5rem)] leading-[1.05]"
          >
            {title}
          </motion.h1>
        </div>
        {lead && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.35, ease: EASE }}
            className="mt-8 max-w-2xl text-base md:text-lg leading-relaxed text-sand/80"
          >
            {lead}
          </motion.p>
        )}
      </div>
    </section>
  );
}
